import styled from 'styled-components';

export const TipTapWrapper = styled.div`
  height: inherit;
  > div:nth-child(4) {
    height: inherit;
  }
`;